/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { authControllerLoginLegacyToken } from '../fn/auth/auth-controller-login-legacy-token';
import { AuthControllerLoginLegacyToken$Params } from '../fn/auth/auth-controller-login-legacy-token';
import { AuthResponseDto } from '../models/auth-response-dto';
import { CreateMyFitAccountIfNotExistsDto } from '../models/create-my-fit-account-if-not-exists-dto';
import { getManyBaseMgmtMemberControllerMember } from '../fn/member/get-many-base-mgmt-member-controller-member';
import { GetManyBaseMgmtMemberControllerMember$Params } from '../fn/member/get-many-base-mgmt-member-controller-member';
import { GetManyMemberResponseDto } from '../models/get-many-member-response-dto';
import { getOneBaseMemberControllerMember } from '../fn/member/get-one-base-member-controller-member';
import { GetOneBaseMemberControllerMember$Params } from '../fn/member/get-one-base-member-controller-member';
import { getOneBaseMgmtMemberControllerMember } from '../fn/member/get-one-base-mgmt-member-controller-member';
import { GetOneBaseMgmtMemberControllerMember$Params } from '../fn/member/get-one-base-mgmt-member-controller-member';
import { Member } from '../models/member';
import { memberControllerMyFitAccount } from '../fn/member/member-controller-my-fit-account';
import { MemberControllerMyFitAccount$Params } from '../fn/member/member-controller-my-fit-account';
import { updateOneBaseMemberControllerMember } from '../fn/member/update-one-base-member-controller-member';
import { UpdateOneBaseMemberControllerMember$Params } from '../fn/member/update-one-base-member-controller-member';

@Injectable({ providedIn: 'root' })
export class MemberApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `authControllerLoginLegacyToken()` */
  static readonly AuthControllerLoginLegacyTokenPath = '/api/auth/login-legacy-token';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authControllerLoginLegacyToken()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authControllerLoginLegacyToken$Response(params: AuthControllerLoginLegacyToken$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthResponseDto>> {
    const obs = authControllerLoginLegacyToken(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authControllerLoginLegacyToken$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authControllerLoginLegacyToken(params: AuthControllerLoginLegacyToken$Params, context?: HttpContext): Observable<AuthResponseDto> {
    const resp = this.authControllerLoginLegacyToken$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AuthResponseDto>): AuthResponseDto => r.body)
    );
  }

  /** Path part for operation `getOneBaseMgmtMemberControllerMember()` */
  static readonly GetOneBaseMgmtMemberControllerMemberPath = '/api/mgmt-members/{id}';

  /**
   * Retrieve a single Member.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOneBaseMgmtMemberControllerMember()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtMemberControllerMember$Response(params: GetOneBaseMgmtMemberControllerMember$Params, context?: HttpContext): Observable<StrictHttpResponse<Member>> {
    const obs = getOneBaseMgmtMemberControllerMember(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a single Member.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOneBaseMgmtMemberControllerMember$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtMemberControllerMember(params: GetOneBaseMgmtMemberControllerMember$Params, context?: HttpContext): Observable<Member> {
    const resp = this.getOneBaseMgmtMemberControllerMember$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Member>): Member => r.body)
    );
  }

  /** Path part for operation `getManyBaseMgmtMemberControllerMember()` */
  static readonly GetManyBaseMgmtMemberControllerMemberPath = '/api/mgmt-members';

  /**
   * Retrieve multiple Members.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getManyBaseMgmtMemberControllerMember()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtMemberControllerMember$Response(params?: GetManyBaseMgmtMemberControllerMember$Params, context?: HttpContext): Observable<StrictHttpResponse<GetManyMemberResponseDto>> {
    const obs = getManyBaseMgmtMemberControllerMember(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve multiple Members.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getManyBaseMgmtMemberControllerMember$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtMemberControllerMember(params?: GetManyBaseMgmtMemberControllerMember$Params, context?: HttpContext): Observable<GetManyMemberResponseDto> {
    const resp = this.getManyBaseMgmtMemberControllerMember$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetManyMemberResponseDto>): GetManyMemberResponseDto => r.body)
    );
  }

  /** Path part for operation `getOneBaseMemberControllerMember()` */
  static readonly GetOneBaseMemberControllerMemberPath = '/api/members/{id}';

  /**
   * Retrieve a single Member.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOneBaseMemberControllerMember()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMemberControllerMember$Response(params: GetOneBaseMemberControllerMember$Params, context?: HttpContext): Observable<StrictHttpResponse<Member>> {
    const obs = getOneBaseMemberControllerMember(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a single Member.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOneBaseMemberControllerMember$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMemberControllerMember(params: GetOneBaseMemberControllerMember$Params, context?: HttpContext): Observable<Member> {
    const resp = this.getOneBaseMemberControllerMember$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Member>): Member => r.body)
    );
  }

  /** Path part for operation `updateOneBaseMemberControllerMember()` */
  static readonly UpdateOneBaseMemberControllerMemberPath = '/api/members/{id}';

  /**
   * Update a single Member.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateOneBaseMemberControllerMember()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOneBaseMemberControllerMember$Response(params: UpdateOneBaseMemberControllerMember$Params, context?: HttpContext): Observable<StrictHttpResponse<Member>> {
    const obs = updateOneBaseMemberControllerMember(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update a single Member.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateOneBaseMemberControllerMember$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOneBaseMemberControllerMember(params: UpdateOneBaseMemberControllerMember$Params, context?: HttpContext): Observable<Member> {
    const resp = this.updateOneBaseMemberControllerMember$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Member>): Member => r.body)
    );
  }

  /** Path part for operation `memberControllerMyFitAccount()` */
  static readonly MemberControllerMyFitAccountPath = '/api/members/my-fit-account';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `memberControllerMyFitAccount()` instead.
   *
   * This method doesn't expect any request body.
   */
  memberControllerMyFitAccount$Response(params?: MemberControllerMyFitAccount$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateMyFitAccountIfNotExistsDto>> {
    const obs = memberControllerMyFitAccount(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `memberControllerMyFitAccount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  memberControllerMyFitAccount(params?: MemberControllerMyFitAccount$Params, context?: HttpContext): Observable<CreateMyFitAccountIfNotExistsDto> {
    const resp = this.memberControllerMyFitAccount$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<CreateMyFitAccountIfNotExistsDto>): CreateMyFitAccountIfNotExistsDto => r.body)
    );
  }

}
